import iconClose from "../../../../images/contents/map/pointinfo/close.svg";
import iconCloseActive from "../../../../images/contents/map/pointinfo/close_active.svg";
import iconCloseHover from "../../../../images/contents/map/pointinfo/close_hover.svg";

export const configPointAreaDh = {
  "data": {
    "Type": "JSON",
    "url": "%links_api_url%/fosterlinks/customer_point/available",
    "update_interval": 3600,
    "retain": true,
    "cache": true,
  }
}

export const configPointAreaExternalDh = {
  "data": {
    "Type": "GeoJSON",
    "retain": true,
    "cache": true,
  }
}

export const configPointAreaLayer = {
  "Name": "PointArea",
  "Renderer": "PointArea",
  "Attributes": {
  }
}

export const configPointAreaExternalLayer = {
  "Name": "PointAreaExternal",
  "Renderer": "PointAreaExternal",
  "Attributes": {
    "features": [],
    "key": "_links_ext_uid",
    "close_button": iconClose,
    "close_button_hover": iconCloseHover,
    "close_button_active": iconCloseActive,
    "tooltip": {
      "font_size": 12,
      "text_color": "#fff",
      "line_color": "#fff",
      "line_width": 0.5,
      "fill_color": "rgba(0,0,0,0.9)",
      "width": 300,
      "padding": 4,
      "padding_top": 12,
      "padding_bottom": 12,
      "padding_left": 12,
      "padding_right": 12,
      "round_corner": 6,
    },
    "popup": {
      "font_size": 12,
      "text_color": "#222",
      "line_color": "#222",
      "line_width": 2,
      "fill_color": "rgba(250,250,250,0.9)",
      "title_fill_color": "rgba(103,93,139,0.7)",
      "title_text_color": "#FFFFFF",
      "width": 350,
      "padding": 4,
      "padding_top": 10,
      "padding_bottom": 10,
      "padding_left": 10,
      "padding_right": 10,
      "round_corner": 6,
      "word_wrap": "break-word"
    }
  }
}
